<template>
  <Modal
    v-bind="{ isVisible }"
    confirm-variant="primary-ghost"
    no-cancel
    :tracking="{
      action: 'state_switch',
      topicKey: 'incorrect_state_detected',
    }"
    @confirm="isVisible = false"
  >
    <template #headline>{{ $t('stateswitch.modal.headline') }}</template>

    <i18n-t keypath="stateswitch.modal.text" scope="global" tag="p">
      <template #state>
        <strong>
          {{ $t(`licensedterritory.${licensedTerritory}`) }}
        </strong>
      </template>
    </i18n-t>

    <Illustration class="illustration mt-200" name="location-redirect" />

    <template #confirm>{{ $t('stateswitch.modal.confirm') }}</template>
  </Modal>
</template>

<script lang="ts" setup>
const { licensedTerritory } = useStateSwitch()

const isVisible = defineModel('isVisible', { default: false, type: Boolean })
</script>

<style lang="scss" scoped>
.illustration {
  width: 24rem;
}
</style>
